module.exports = __webpack_public_path__ + "media/img/covers/profile-cover-8-171d960de8e2f15dd6eba40f04c9dfd8.jpg";